import { render, staticRenderFns } from "./navbar-parent-pay.vue?vue&type=template&id=58e191de"
import script from "./navbar-parent-pay.vue?vue&type=script&lang=js"
export * from "./navbar-parent-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports